import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Emergency(props) {
  const { height, width, backgroundColor, iconColor } = props;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
      <polygon
        fill={backgroundColor}
        opacity={0.4}
        points="66.43 54.15 78 54.15 78 67.01 66.43 67.01 66.43 78.58 53.57 78.58 53.57 67.01 66.43 54.15"
      />
      <polygon
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        points="66.43 67.01 78 67.01 78 54.15 66.43 54.15 66.43 42.58 53.57 42.58 53.57 54.15 42 54.15 42 67.01 53.57 67.01 53.57 78.58 66.43 78.58 66.43 67.01"
      />
      <circle fill="none" stroke={iconColor} strokeMiterlimit={10} strokeWidth="2.33px" cx="60" cy="60.66" r="31.67" />
    </svg>
  );
}

Emergency.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string
};

Emergency.defaultProps = {
  height: undefined,
  width: 120,
  iconColor: colors.colorGrey02,
  backgroundColor: colors.iconGreen
};

export default Emergency;
